import { render, staticRenderFns } from "./casesTable.vue?vue&type=template&id=1e1cd910&lang=pug"
import script from "./casesTable.vue?vue&type=script&lang=js"
export * from "./casesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports